<app-header-nav></app-header-nav>

<router-outlet></router-outlet>


<app-footer></app-footer>


